var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { processPayment } from '../utils';

export default processPayment('/trustly/deposit/process', {
  amount: 'required',
  sessionId: 'required',
  userId: 'required',
  merchantId: 'required'
}, function (data, user) {
  return user ? _extends({}, data, { personId: user.PersonId }) : data;
});